import React from "react";
import styled from "styled-components";
import LinkedInIcon from "../../icons/LinkedIn.svg";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { graphql, useStaticQuery } from "gatsby";

const Section = styled.section`
  .imgWrapper {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    height: 350px;
    margin-bottom: 1.5rem;
    & img {
      object-position: 50% 25%;
    }
  }

  h5 {
    margin-bottom: 0.5rem;
  }

  svg path {
    fill: black;
  }
`;

const Team = () => {
  const query = useStaticQuery(graphql`
    query getTeamPics {
      allFile(filter: { relativeDirectory: { eq: "Team" } }) {
        edges {
          node {
            name
            childImageSharp {
              gatsbyImageData(width: 784, height: 700)
            }
          }
        }
      }
    }
  `);

  const team = [
    {
      id: "Aditya",
      name: "Aditya Kumar",
      desg: "Co-founder & CEO",
      desc: (
        <p>
          Aditya was previously the founder of Qbera, a near-prime credit
          origination marketplace which he scaled to $25mm in AUM and sold to
          InCred Financial Services in 2020, where he headed the consumer
          lending business. Aditya has over 16 years of experience in
          entrepreneurship and financial services, with a Bachelor’s Degree in
          Economics from Warwick University. By night, Aditya is the lead singer
          of a rock & blues band in Bangalore called Strange Brew.
        </p>
      ),
      link: "https://www.linkedin.com/in/akumar29/",
    },
    {
      id: "Sankalp",
      name: "Sankalp Mathur",
      desg: "Co-founder & CRO",
      desc: (
        <p>
          Sankalp spent 5 years with growing fintech startups - helping build
          the businesses from 0 to 1 from a risk bearing and scaling
          perspective. He spent over 13 years with banks like Citi, HSBC and
          Barclays understanding the systems and processes of Retail Banking
          across a variety of products and developing expertise in Risk,
          Analytics, Underwriting, Operations and Collections. He is a graduate
          from IIT Kanpur.
        </p>
      ),
      link: "https://www.linkedin.com/in/sankalp-mathur/",
    },
    {
      id: "Vijay",
      name: "Vijay Sachidanand",
      desg: "Chief Operating Officer",
      desc: (
        <p>
          Vijay has over 25 years of general management and product leadership
          experience, mostly in early-stage fin-tech environments. He was
          previously on Gain Credit's executive team serving as general manager
          of Drafty, a UK consumer lending business which he took from the seed
          stage to a $100m fundraise. Before that, he built Amazon Money Store
          (Amazon UK's embedded credit marketplace) and helped start iMark.com
          (a US-based marketplace for surplus industrial assets), which was sold
          for $340m. Vijay has an MBA from London Business School and
          undergraduate degrees in business and engineering from the University
          of Pennsylvania. Outside the office, Vijay can often be found at his
          local pub cheering on his favourite football and cricket teams.
        </p>
      ),
      link: "https://uk.linkedin.com/in/vijaysachidanand",
    },
    {
      id: "Viswanath",
      name: "Viswanath Kommalapati",
      desg: "Chief Technology Officer",
      desc: (
        <p>
          Viswanath has over 15 years of experience in technology, designing and
          building systems that operate at scale. He has been a two-time
          founder, having sold his last startup (FanDuniya) to Dream Sports. He
          is a B.Tech graduate from IIT Madras.
        </p>
      ),
      link: "https://www.linkedin.com/in/kviswanath/",
    },
    {
      id: "Naren",
      name: "Narendran P",
      desg: "Head - Collections & Operations",
      desc: (
        <p>
          Narendran is a unique blend of skills going from field collections to
          data analytics. An expert at building and managing Collection and Ops
          Infrastructure for scale from scratch. Holds over 20 years of
          experience with financial behemoths like HDFC, ICICI, GE Money and
          Bajaj and hyper growth start-ups like Navi and Moneytap. Narendra
          holds a commerce degree from University of Madras.
        </p>
      ),
      link: "https://www.linkedin.com/in/narendran-p-19880b173/",
    },
    {
      id: "Laasyaa",
      name: "Laasyaa Chadaga",
      desg: "Head - Finance & Strategy",
      desc: (
        <p>
          Laasyaa focuses on strategic initiatives and keeping the money flowing
          at Niro. A career investment banker with 12+ years of experience, she
          has a deep understanding of businesses and has successfully led
          fundraising and M&A transactions across multiple sectors, most notably
          BFSI. She enjoys playing poker and loves the outdoors, with a passion
          for travelling the world.
        </p>
      ),
      link: "https://www.linkedin.com/in/laasyaa-p-chadaga-b317bb2/",
    },
    {
      id: "Vinay",
      name: "Vinay Gurram",
      desg: "VP - Engineering",
      desc: (
        <p>
          Vinay is a hard core engineer who loves logic, algorithm and all
          things Java. An entrepreneur at the core he conceives a multitude of
          brilliant ideas on a routine basis. He has held key engineering
          positions in a number of different high growth start-ups before Niro.
          Vinay holds a Masters in Science from IIT Mumbai.
        </p>
      ),
      link: "https://www.linkedin.com/in/vinay-gurram/",
    },
    {
      id: "Nishanth",
      name: "Nishanth Ashok",
      desg: "Vice President - Growth & Marketing",
      desc: (
        <p>
          Nishanth focuses on growth initiatives & marketing strategy at Niro.
          With 7+ years of expertise in marketing, he drives user acquisition
          and retention through data-driven, customer-centric campaigns. When
          not in the office, he is often found on a hiking trail, enjoying the
          outdoors. Nishanth holds a PGDM in Marketing & Strategy from the Great
          Lakes Institute of Management.
        </p>
      ),
      link: "https://www.linkedin.com/in/nishanthashok/",
    },
    {
      id: "Vanita",
      name: "Vanita Dalvi",
      desg: "AVP Sales",
      desc: (
        <p>
          Vanita has 15 years of experience in sales within the banking and
          fintech domain. She brings with her deep understanding of multiple
          products business loans, digital personal loans, and credit lines
          across several companies such as HDFC Bank, Capital Float, Qbera
          Finance, and Incred Finance.
        </p>
      ),
      link: "https://www.linkedin.com/in/vanita-dalvi-58b810169/",
    },
    {
      id: "Monisha",
      name: "Monisha Verma",
      desg: "AVP-People & Culture",
      desc: (
        <p>
          Monisha has 9 years of experience in human resources. Her passion is
          to look at problems from a "Human" angle. She has a joyful and
          positive outlook which she brings to every aspect of her work. She has
          over 5+ years of experience within the fintech and banking industry.
          She is a double masters in MBA and M.Sc in physics.
        </p>
      ),
      link: "https://www.linkedin.com/in/monisha-verma-b17a5825/",
    },
    {
      id: "Shakun",
      name: "Shakun Banthia",
      desg: "AVP Business",
      desc: (
        <p>
          Shakun has 12 years of experience. She has worked across various
          start-ups and spent 5 years working within the Fintech and Banking
          industries. She dons multiple hats at Niro including public relations,
          marketing, and growth. She has a dual MBA in finance and marketing
          from the Indian School of Business. Outside of work she loves
          adventure sports and travelling.
        </p>
      ),
      link: "https://www.linkedin.com/in/shakun-banthia-0a3ab020/",
    },
    {
      id: "Piyush",
      name: "Piyush Goel",
      desg: "AVP Finance",
      desc: (
        <p>
          Piyush is a Chartered Accountant with 5 years of hands-on experience
          and overall experience of more than 7 years in finance, accounts,
          taxation, audit, and corporate compliance. He feels motivated by the
          pace and aggressiveness of startups. Playing outdoor games and
          travelling keeps him busy in his free time.
        </p>
      ),
      link: "https://www.linkedin.com/in/shakun-banthia-/",
    },
    {
      id: "Prashanth",
      name: "Prashanth P",
      desg: "AVP collections",
      desc: (
        <p>
          Prashanth has over 20 years of progressive experience in Risk
          management, Collections & people management. He has set up a
          collections team from scratch and has an in-depth understanding of
          setting up collections and agent networks. He is a people person and
          loves parties and social gatherings. He enjoys camping in the wild and
          listening to the crackle of bonfires.
        </p>
      ),
      link: " https://www.linkedin.com/in/prashanth-rotti-2539b617/",
    },
    {
      id: "Ankit",
      name: "Ankit Verma",
      desg: "Manager - Business Operations",
      desc: (
        <p>
          A constant hustler, Ankit Verma has developed his skills in credit
          risk analysis, business operations, data analytics, process innovation
          and collections during his tenure of 6 years working for early-stage
          startups. A problem-solver at heart, he is currently pursuing a
          Master’s degree in data science and engineering at BITS Pilani.
        </p>
      ),
      link: "https://www.linkedin.com/in/ankit-verma-862a81100/",
    },
    {
      id: "Louhit",
      name: "Kumar Louhit",
      desg: "Senior Product Manager",
      desc: (
        <p>
          Louhit has 7+ years of tech startup experience. With multiple shipped
          products (0 to 1/1 to n) across various domains, he brings a deep
          understanding of technology, market dynamics, product strategy, and
          product development processes. Louhit loves football (GGMU) and enjoys
          travelling. He is a design graduate from NIFT Bangalore with an MBA
          from IIM Trichy.
        </p>
      ),
      link: "https://www.linkedin.com/in/kumar-louhit-3504488b/",
    },
  ];

  query.allFile.edges.forEach((item) => {
    for (let j = 0; j <= team.length - 1; j++) {
      if (item.node.name === team[j].id) {
        console.log(team[j]);
        team[j].img = getImage(item.node);
      }
    }
  });
  return (
    <Section>
      <div className="container">
        <div className="row mb-5 pb-md-5 text-center">
          <h2>Meet our Team</h2>
        </div>

        <div className="row row-cols-xl-3 row-cols-md-2 row-cols-1">
          {team.map((item, i) => (
            <TeamCard {...item} key={`teamCard${i}`} />
          ))}
        </div>
      </div>
    </Section>
  );
};

const TeamCard = (props) => {
  return (
    <div className="col mb-5 px-4">
      <GatsbyImage image={props.img} alt="" className="imgWrapper" />
      <div className="d-flex justify-content-between mb-3">
        <div className="d-flex flex-column pe-5">
          <h5>{props.name}</h5>
          <span>{props.desg}</span>
        </div>
        <a target="_blank" href={props.link} rel="noreferrer noopener" alt="">
          <LinkedInIcon />
        </a>
      </div>
      <div
        className="mb-5"
        style={{
          textAlign: "justify",
          textJustify: "inter-word",
        }}
      >
        {props.desc}
      </div>
    </div>
  );
};

export default Team;
